import 'hammerjs';
import './monaco-environment';
import { enableProdMode, importProvidersFrom } from '@angular/core';
import './app/ag-grid-setup';
import { bootstrapApplication } from '@angular/platform-browser';

import { AppModule } from './app/app.module';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';
declare global {
  interface Window {
    Rakanto: any;
  }
}

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [importProvidersFrom(AppModule)]
})
  .catch(err => console.error(err));
